import { Component, OnInit } from '@angular/core';
import { fciWebsiteService } from '../../../service/fci-website.service';
import { environment } from 'src/environments/environment'; 
import { CustomServiceService } from './../../../service/custom-service.service';
import Swal from 'sweetalert2';
declare let Swiper: any;
declare let $: any;
import {ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {

  language: any = '';

  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL;
  toogaleValue:any='';
  

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private httpservice: CustomServiceService, public translate: TranslateService) { 

    this.toogaleValue=window.localStorage.getItem('themeColor');
    }
 
  // confirmBox(): void {
  //   const result = window.confirm('You are being redirected to an external website. Please note that National Portal is not responsible for external websites content & privacy policies');
  //   if (result) {
  //     // Perform the action if the user clicks 'OK'
  //     // For example, navigate to a different page or execute a function
  //     // e.g., this.router.navigate(['/another-page']);
  //   } else {
  //     // Perform any actions or handle the cancellation here
  //   }
  // }
  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime();
  impLinktimeInteval:any = null;
  ngOnInit(): void {
    this.impLinktimeInteval = setInterval(():any=>{
      if(!this.fciwebservice.ImportantLinkData().progress){
        this.getAllImpLinks();
        clearInterval(this.impLinktimeInteval);
      }
    }, 500);

    // FOR CLIENTS LINK CAROUSEL - STARTS
    new Swiper("#links-swiper", {
      // Optional parameters
      slidesPerView: 6,
      direction: 'horizontal',
      loop: true,
      // autoplay: true,
      spaceBetween: 10,

      breakpoints: {
        '1440': {
          slidesPerView: 6,
          spaceBetween: 5,
        },
        '1024': {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        '768': {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        '320': {
          slidesPerView: 1,
          spaceBetween: 40,
        },

      },
      // Navigation arrows
      navigation: {
        nextEl: '.clients-next',
        prevEl: '.clients-prev',
      }
    });
    // FOR CLIENTS LINK CAROUSEL - ENDS

    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 
    
  }
  
  content_apiresponse:any;
  impLInk :any =[];
  getAllImpLinks():any{
    this.impLInk =[];
    let alldata:any = this.fciwebservice.ImportantLinkData();
    if(alldata.data.length <= 0){
      return false;
    }
    this.impLInk =alldata.data;
    return true;
  }

  goToExtLink(url: any) {
    Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }
}
